import Contact10 from './Contact10'
export default Contact10
